import React from 'react';
import StarsIcon from '../styles/StarsIcon';
import { Button } from './ui';

const Pagination = ({ nPages, currentPage, setCurrentPage }) => {
    if (nPages === 0) return null; // Hide pagination if no pages

    const pageNumbers = [...Array(nPages + 1).keys()].slice(1);

    const goToNextPage = () => {
        if (currentPage < nPages) setCurrentPage(currentPage + 1);
    };
    const goToPrevPage = () => {
        if (currentPage > 1) setCurrentPage(currentPage - 1);
    };

    return (
        <nav aria-label="Pagination" className="tw-mt-4 tw-flex tw-flex-wrap tw-items-center tw-justify-end tw-gap-2">
            <Button
                variant="icon"
                className="tw-border-solid"
                size="sm"
                iconOnly
                aria-label="Previous page"
                disabled={currentPage === 1}
                onClick={goToPrevPage}
            >
                <StarsIcon name="chevronLeft" className="tw-h-4 tw-w-4 tw-shrink-0" />
            </Button>

            {pageNumbers.map(pgNumber => (
                <Button
                    key={pgNumber}
                    variant={currentPage === pgNumber ? 'primary' : 'quiet'}
                    className="tw-border-solid"
                    size="sm"
                    aria-current={currentPage === pgNumber ? 'page' : undefined}
                    onClick={() => setCurrentPage(pgNumber)}
                >
                    {pgNumber}
                </Button>
            ))}

            <Button
                variant="icon"
                className="tw-border-solid"
                size="sm"
                iconOnly
                aria-label="Next page"
                disabled={currentPage === nPages}
                onClick={goToNextPage}
            >
                <StarsIcon name="chevron" className="tw-h-4 tw-w-4 tw-shrink-0" />
            </Button>
        </nav>
    );
};

export default Pagination;
